<i class="far fa-times close" (click)="closeDialog()"></i>

<header class="ui-header-multimedia" mat-dialog-title>
	<i [ngClass]="content.fileTypeId | fileTypeIcon: 'variant'"></i>
	<h1 class="title">{{content.name}}</h1>
	<!-- TODO PENDIENTE SABER COMO OBTENER EL NIVEL COMPLETO DEL RECURSO -->
	<!-- <p *ngIf="multimedia.subtitle" class="subtitle">{{multimedia.subtitle}}</p> -->
</header>

<mat-dialog-content class="dialog-content">
	<div class="paragraphs">
		
		<div class="ui-paragraphs-multimedia" *ngIf="content.purposeId">
			<h2 class="title">Propósito</h2>
			<p class="subtitle">
				{{content.purposeDescription || ''}}
			</p>
		</div>

		
		<div class="ui-paragraphs-multimedia" *ngIf="content.formativeFieldId">
			<h2 class="title">Campo de formación</h2>
			<p class="subtitle">{{content.formativeFieldDescription || ''}}</p>
		</div>
	</div>

	<!-- MULTIMEDIAS POR TIPO-->
	<section class="ui-section-multimedia">
		<div class="audio" *ngIf="showAudio()">
			<audio controls [attr.controlsList]="getControlsList()" (play)="onPlayAudio()"> 
				<source [src]="content.urlContent" />
			</audio>
		</div>
		<div class="mt-3" *ngIf="isDownloadSound && showAudio()">
			<button type="button" class="btn btn-block btn-primary rounded-pill download" (click)="downloadFile()">DESCARGAR AUDIO</button>
		</div>

		<div class="document" *ngIf="showDocument()">
			<ng2-pdfjs-viewer
				class="pdf"
				[pdfSrc]="getUrlPdf()"
				[downloadFileName]="getFileName()"
				viewerId="1"
				[download]="canDownloadDocument()"
				[openFile]="false"
				[print]="canDownloadDocument()"
				[viewBookmark]="false"
				locale="es-MX"
				[showSpinner]="true"
				(onBeforePrint)="onBeforePrint()"
				viewerId="multimediaPdfViewer"
				>
			</ng2-pdfjs-viewer>
		</div>

		<div class="video" *ngIf="showVideo()">
			<div id="vimeo-video" class="vimeo"></div>

			<!-- <iframe
				#videoFrame
				[src]="getUrlMultimedia() | safe: 'resourceUrl'"
				class="iframe"
				frameborder="0"
				allowfullscreen
				>
			</iframe> -->
		</div>

		<div class="link" *ngIf="showLink()">
			<button
			class="btn btn-primary btn-lg rounded-pill download"
			type="button"
			(click)="refLink.click()">
			Visitar sitio interactivo: {{content.name}}
		</button>

		<a href="{{content.urlContent}}"
			target="_blank"
			rel="noopener noreferrer"
			hidden
			#refLink>
		</a>
		</div>
	</section>
</mat-dialog-content>
<ng-container *ngIf="!showAudio() else audioTemplate">
	<mat-dialog-actions class="btn-actions" *ngIf="multimedia.showButtonDownload">		
		<button
			class="btn btn-primary btn-lg rounded-pill download"
			type="button"
			(click)="refDownload.click()">
			Descargar recurso
			<i class="fas fa-download"></i>
		</button>

		<a href="{{getUrlMultimedia()}}"
			target="_blank"
			rel="noopener noreferrer"
			hidden
			download
			#refDownload>
		</a>
	</mat-dialog-actions>
</ng-container>
<ng-template #audioTemplate>
	<mat-dialog-actions class="btn-actions" *ngIf="multimedia.showButtonDownload">	
		<button
			class="btn btn-primary btn-lg rounded-pill download"
			type="button"
			(click)="downloadFile()">
			Descargar recurso
			<i class="fas fa-download"></i>
		</button>
	</mat-dialog-actions>
</ng-template>
